import React from 'react';
import { Hero } from './components/Hero';
import { AboutKarina } from './components/AboutKarina';
import { TransitionBlock } from './components/TransitionBlock';
import { Products } from './components/Products';
import { Description } from './components/Description';
import { Benefits } from './components/Benefits';
import { Testimonials } from './components/Testimonials';
import { CTASection } from './components/CTASection';
import { ShopifyDescription } from './components/ShopifyDescription';
import { Footer } from './components/Footer';
export function App() {
  return <div className="min-h-screen bg-nude-light font-sans selection:bg-gold selection:text-luxury-black" data-id="element-0">
      {/* Floating Badge Example - can be positioned anywhere, placing it fixed for demo */}
      <div className="fixed bottom-6 right-6 z-50 animate-bounce" data-id="element-1">
        <div className="bg-white text-luxury-black font-bold text-xs tracking-wider uppercase px-4 py-2 rounded-full shadow-lg border border-gold/30 flex items-center gap-2" data-id="element-2">
          ✨ NUEVO
        </div>
      </div>

      <main data-id="element-3">
        <Hero data-id="element-4" />
        <AboutKarina data-id="element-5" />
        <TransitionBlock data-id="element-6" />
        <Products data-id="element-7" />
        <Description data-id="element-8" />
        <Benefits data-id="element-9" />
        <Testimonials data-id="element-10" />
        <CTASection data-id="element-11" />
        <ShopifyDescription data-id="element-12" />
      </main>

      <Footer data-id="element-13" />
    </div>;
}